(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ar-collection-catalog"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',event=>{
  if(!event.target.matches('[data-catalog-sort], [data-catalog-available]')) return;
  const form=event.target.closest('[data-catalog-form]'),url=new URL(window.location.href);
  const sort=form.querySelector('[data-catalog-sort]').value;
  if(sort) url.searchParams.set('sort_by',sort);else url.searchParams.delete('sort_by');
  const stock=form.querySelector('[data-catalog-available]');
  if(stock){if(stock.checked)url.searchParams.set('filter.v.availability','1');else url.searchParams.delete('filter.v.availability');}
  url.searchParams.delete('page');url.hash=form.closest('[data-ar-catalog]').querySelector('.ar-catalog__products').id;
  window.location.assign(url.toString());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ar-safety-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ar-safety-center')) {
    customElements.define('ar-safety-center', class extends HTMLElement {
      connectedCallback() {
        this.checkItems = Array.from(this.querySelectorAll('[data-check-item]'));
        this.prePowerCheckCount = Number(this.dataset.prePowerCheckCount || Math.max(0, this.checkItems.length - 1));
        this.progressLabel = this.querySelector('[data-progress-label]');
        this.progressBar = this.querySelector('[data-progress-bar]');
        this.progressTrack = this.querySelector('[data-progress-track]');
        this.progressNext = this.querySelector('[data-progress-next]');
        this.checkAlert = this.querySelector('[data-check-alert]');
        this.printSheet = this.querySelector('[data-print-sheet]');
        this.handleBeforePrint = () => this.activatePrintSheet();
        this.handleAfterPrint = () => this.cleanupPrintSheet();
        this.handleHashChange = () => this.openHashDisclosure();
        this.handlePageShow = () => this.openHashDisclosure();
        this.handleDecisionDisclosure = (event) => {
          const link = event.target.closest('.ar-safety__decision-link[href^="#"]');
          if (!link || !this.contains(link)) return;
          this.rememberDisclosure(link.getAttribute('href'));
        };
        window.addEventListener('beforeprint', this.handleBeforePrint);
        window.addEventListener('afterprint', this.handleAfterPrint);
        window.addEventListener('hashchange', this.handleHashChange);
        window.addEventListener('pageshow', this.handlePageShow);
        this.addEventListener('click', this.handleDecisionDisclosure);
        this.popupObserver = new MutationObserver(() => this.removeSafetyPopup());
        this.popupLockObserver = new MutationObserver(() => {
          window.requestAnimationFrame(() => this.releaseOrphanedPopupLock());
        });
        const popupObserverTarget = document.body || document.documentElement;
        if (popupObserverTarget) {
          this.popupObserver.observe(popupObserverTarget, { childList: true, subtree: true });
          this.popupLockObserver.observe(popupObserverTarget, { attributes: true, attributeFilter: ['class'] });
        }
        this.removeSafetyPopup();
        this.checkItems.forEach((item) => {
          item.querySelectorAll('[data-check-result]').forEach((input) => {
            input.addEventListener('change', () => this.updateProgress());
          });
        });
        this.querySelector('[data-check-reset]')?.addEventListener('click', () => {
          this.checkItems.forEach((item) => {
            item.querySelectorAll('[data-check-result]').forEach((input) => { input.checked = false; });
          });
          this.updateProgress();
          this.checkItems[0]?.querySelector('[data-check-result]')?.focus();
        });
        this.querySelector('[data-print-checklist]')?.addEventListener('click', () => this.printChecklist());
        this.querySelector('[data-share-checklist]')?.addEventListener('click', (event) => this.shareChecklist(event.currentTarget));
        const lawGate = this.querySelector('[data-law-gate]');
        const productType = lawGate?.querySelector('[data-product-type]');
        const stateSelect = lawGate?.querySelector('[data-state-select]');
        const lawOpen = lawGate?.querySelector('[data-law-open]');
        const lawMessage = lawGate?.querySelector('[data-law-message]');
        const lawSource = lawGate?.querySelector('[data-law-source]');
        const setLawSource = (url) => {
          if (!lawSource) return;
          lawSource.hidden = !url;
          if (url) lawSource.href = url;
        };
        const updateEbikeState = () => {
          if (!stateSelect || !lawOpen) return;
          const option = stateSelect.options[stateSelect.selectedIndex];
          lawOpen.dataset.target = stateSelect.value || lawGate.dataset.lawsUrl;
          lawOpen.textContent = stateSelect.value ? `Open ${option.text} e-bike guide` : 'Open state e-bike law hub';
          const verified = option?.dataset.verified;
          if (lawMessage) lawMessage.textContent = stateSelect.value
            ? `${verified ? `State record last verified ${verified}. ` : ''}Check city, park, trail, and land-manager rules before riding.`
            : 'Choose a state for its maintained e-bike record, verification date, and official sources.';
          setLawSource(option?.dataset.sourceUrl || '');
        };
        const updateLawGate = () => {
          if (!productType || !stateSelect || !lawOpen || !lawGate) return;
          const type = productType.value;
          stateSelect.value = '';
          setLawSource('');
          if (type === 'classed') {
            stateSelect.disabled = lawGate.dataset.hasStates !== 'true';
            lawOpen.disabled = false;
            updateEbikeState();
            return;
          }
          stateSelect.disabled = true;
          if (type === 'ppb') {
            lawOpen.disabled = false;
            lawOpen.dataset.target = lawGate.dataset.ppbUrl;
            lawOpen.textContent = 'Open PPB use guide';
            if (lawMessage) lawMessage.textContent = 'E-bike class pages do not establish public-road eligibility for a PPB. Use PPBs only on permitted private property, closed courses, or off-road areas.';
            return;
          }
          if (type === 'unclear') {
            lawOpen.disabled = false;
            lawOpen.dataset.target = lawGate.dataset.supportUrl;
            lawOpen.textContent = 'Contact Support for classification review';
            if (lawMessage) lawMessage.textContent = 'Do not assume public-road eligibility when the order, label, bike page, and manual do not identify the same configuration.';
            return;
          }
          lawOpen.disabled = true;
          lawOpen.dataset.target = '';
          lawOpen.textContent = 'Choose bike category first';
          if (lawMessage) lawMessage.textContent = 'Do not use a model-family name or manual title to guess classification.';
        };
        productType?.addEventListener('change', updateLawGate);
        stateSelect?.addEventListener('change', updateEbikeState);
        lawOpen?.addEventListener('click', () => {
          if (!lawOpen.disabled && lawOpen.dataset.target) window.location.assign(lawOpen.dataset.target);
        });
        updateLawGate();
        const jumpLinks = Array.from(this.querySelectorAll('.ar-safety__jump a'));
        const jumpMenu = this.querySelector('[data-jump-menu]');
        const jumpMore = this.querySelector('[data-jump-more]');
        const jumpCurrent = this.querySelector('[data-jump-current]');
        const jumpTargets = Array.from(new Set(jumpLinks.map((link) => this.querySelector(link.getAttribute('href'))).filter(Boolean)));
        jumpLinks.forEach((link) => {
          link.addEventListener('click', () => {
            if (jumpMenu) jumpMenu.open = false;
            if (jumpMore) jumpMore.open = false;
          });
        });
        if ('IntersectionObserver' in window && jumpTargets.length) {
          this.jumpObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const activeHref = `#${entry.target.id}`;
              jumpLinks.forEach((link) => {
                const active = link.getAttribute('href') === activeHref;
                if (active) link.setAttribute('aria-current', 'location');
                else link.removeAttribute('aria-current');
              });
              const activeLink = jumpLinks.find((link) => link.getAttribute('href') === activeHref);
              if (jumpMore) {
                const moreIsCurrent = Array.from(jumpMore.querySelectorAll('a')).some((link) => link.getAttribute('href') === activeHref);
                jumpMore.toggleAttribute('data-current', moreIsCurrent);
              }
              if (jumpCurrent && activeLink) jumpCurrent.textContent = activeLink.textContent.trim();
            });
          }, { rootMargin: '-28% 0px -64% 0px', threshold: 0 });
          jumpTargets.forEach((target) => this.jumpObserver.observe(target));
        }
        this.openHashDisclosure();
        this.openRememberedDisclosure();
        window.requestAnimationFrame(() => this.openHashDisclosure());
        this.hashDisclosureTimer = window.setTimeout(() => this.openHashDisclosure(), 80);
        this.updateProgress();
      }
      removeSafetyPopup() {
        const selector = '[role="dialog"][aria-modal="true"][aria-label="POPUP Form"][data-kl-scroll-locking-modal="true"]';
        document.querySelectorAll(selector).forEach((dialog) => {
          const wrapper = dialog.parentElement?.parentElement;
          if (wrapper?.parentElement === document.body) wrapper.remove();
          else dialog.remove();
        });
        this.releaseOrphanedPopupLock();
      }
      releaseOrphanedPopupLock() {
        const lockingDialog = document.querySelector('[role="dialog"][data-kl-scroll-locking-modal="true"]');
        if (!lockingDialog) document.body.classList.remove('klaviyo-prevent-body-scrolling');
      }
      openHashDisclosure() {
        if (!window.location.hash) return;
        let id = window.location.hash.slice(1);
        try { id = decodeURIComponent(id); } catch { return; }
        this.openDisclosureById(id);
      }
      openDisclosureById(id) {
        const target = document.getElementById(id);
        if (!target || !this.contains(target)) return false;
        const disclosure = target.matches('details') ? target : target.closest('details');
        if (!disclosure || !this.contains(disclosure)) return false;
        disclosure.open = true;
        return true;
      }
      rememberDisclosure(href) {
        if (!href || href.charAt(0) !== '#') return;
        let id = href.slice(1);
        try { id = decodeURIComponent(id); } catch { return; }
        if (!this.openDisclosureById(id)) return;
        try {
          window.sessionStorage.setItem('ar-safety-return-disclosure', JSON.stringify({
            id,
            path: window.location.pathname,
            expiresAt: Date.now() + 5 * 60 * 1000,
          }));
        } catch {}
      }
      openRememberedDisclosure() {
        let record;
        try {
          record = JSON.parse(window.sessionStorage.getItem('ar-safety-return-disclosure') || 'null');
          window.sessionStorage.removeItem('ar-safety-return-disclosure');
        } catch { return; }
        if (!record || record.path !== window.location.pathname || !record.id || record.expiresAt < Date.now()) return;
        this.openDisclosureById(record.id);
      }
      async shareChecklist(button) {
        const url = button?.dataset.shareUrl;
        const status = this.querySelector('[data-share-status]');
        if (!url) return;
        try {
          if (navigator.share) {
            await navigator.share({
              title: 'Ariel Rider pre-ride safety checklist',
              text: 'Use this checklist before every ride.',
              url
            });
            if (status) status.textContent = 'Checklist shared.';
            return;
          }
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(url);
          } else {
            const copyField = document.createElement('textarea');
            copyField.value = url;
            copyField.setAttribute('readonly', '');
            copyField.style.position = 'fixed';
            copyField.style.opacity = '0';
            document.body.appendChild(copyField);
            copyField.select();
            document.execCommand('copy');
            copyField.remove();
          }
          if (status) status.textContent = 'Checklist link copied. Paste it into a text or email.';
        } catch (error) {
          if (error?.name === 'AbortError') return;
          if (status) status.textContent = `Copy this link: ${url}`;
        }
      }
      preparePrintSheet() {
        document.querySelectorAll('.ar-safety__print-sheet--active').forEach((sheet) => sheet.remove());
        const sheet = this.printSheet?.cloneNode(true);
        if (!sheet) return null;
        sheet.classList.add('ar-safety__print-sheet--active');
        sheet.removeAttribute('aria-hidden');
        const results = this.checkItems.map((item) => this.getCheckState(item));
        sheet.querySelectorAll('[data-print-check-index]').forEach((item) => {
          const index = Number(item.dataset.printCheckIndex);
          const result = results[index] || 'unanswered';
          item.dataset.result = result;
          const passMark = item.querySelector('[data-print-pass-mark]');
          const attentionMark = item.querySelector('[data-print-attention-mark]');
          if (passMark) passMark.textContent = result === 'pass' ? 'X' : '';
          if (attentionMark) attentionMark.textContent = result === 'attention' ? 'X' : '';
        });
        const answered = results.filter((result) => result !== 'unanswered').length;
        const attention = results.filter((result) => result === 'attention').length;
        const printSummary = sheet.querySelector('[data-print-summary]');
        if (printSummary) {
          if (attention) printSummary.textContent = `STOP: ${attention} ${attention === 1 ? 'check needs' : 'checks need'} attention. Do not ride.`;
          else if (answered < results.length) printSummary.textContent = `INCOMPLETE: ${answered} of ${results.length} answered. Finish every check before riding.`;
          else printSummary.textContent = `All ${results.length} items marked Pass. This rider-recorded checklist is not a safety certification.`;
        }
        return sheet;
      }
      activatePrintSheet() {
        const activeSheet = document.querySelector('.ar-safety__print-sheet--active');
        if (activeSheet) return activeSheet;
        const sheet = this.preparePrintSheet();
        if (!sheet) return null;
        document.body.appendChild(sheet);
        document.body.classList.add('ar-safety-print-mode');
        sheet.getBoundingClientRect();
        return sheet;
      }
      cleanupPrintSheet() {
        document.querySelectorAll('.ar-safety__print-sheet--active').forEach((sheet) => sheet.remove());
        document.body.classList.remove('ar-safety-print-mode');
      }
      async printChecklist() {
        if (!this.activatePrintSheet()) return;
        try {
          await new Promise((resolve) => window.requestAnimationFrame(() => window.requestAnimationFrame(resolve)));
          window.print();
        } catch {
          this.cleanupPrintSheet();
        }
      }
      disconnectedCallback() {
        this.jumpObserver?.disconnect();
        this.popupObserver?.disconnect();
        this.popupLockObserver?.disconnect();
        window.removeEventListener('beforeprint', this.handleBeforePrint);
        window.removeEventListener('afterprint', this.handleAfterPrint);
        window.removeEventListener('hashchange', this.handleHashChange);
        window.removeEventListener('pageshow', this.handlePageShow);
        this.removeEventListener('click', this.handleDecisionDisclosure);
        window.clearTimeout(this.hashDisclosureTimer);
      }
      getCheckState(item) {
        return item?.querySelector('[data-check-result]:checked')?.value || 'unanswered';
      }
      updateDependentChecks() {
        this.checkItems.forEach((item, index) => {
          const requiresPreviousPass = item.dataset.requiresPreviousPass === 'true';
          const previousChecksPass = !requiresPreviousPass
            || this.checkItems.slice(0, index).every((previous) => this.getCheckState(previous) === 'pass');
          const unlocked = !requiresPreviousPass || previousChecksPass;
          item.classList.toggle('is-locked', !unlocked);
          item.setAttribute('aria-disabled', String(!unlocked));
          item.disabled = !unlocked;
          const inputs = Array.from(item.querySelectorAll('[data-check-result]'));
          inputs.forEach((input) => { input.disabled = !unlocked; });
          if (!unlocked) inputs.forEach((input) => { input.checked = false; });
          const gateNote = item.querySelector('[data-check-gate-note]');
          if (gateNote) {
            gateNote.textContent = unlocked
              ? `Checks 1 through ${this.prePowerCheckCount} are marked Pass. Follow the powered-check procedure in the current manual for your model and configuration. If the procedure is missing or unclear, do not improvise. Contact Support.`
              : `Available after checks 1 through ${this.prePowerCheckCount} are marked Pass.`;
          }
        });
      }
      updateProgress() {
        this.updateDependentChecks();
        const results = this.checkItems.map((item) => {
          const result = this.getCheckState(item);
          item.dataset.result = result;
          return result;
        });
        const total = results.length;
        const answered = results.filter((result) => result !== 'unanswered').length;
        const passed = results.filter((result) => result === 'pass').length;
        const attention = results.filter((result) => result === 'attention').length;
        const remaining = total - answered;
        let label = `${answered} of ${total} answered. ${passed} marked Pass. ${remaining} remaining.`;
        if (attention) label = `${answered} of ${total} answered. ${passed} marked Pass. ${attention} ${attention === 1 ? 'needs' : 'need'} attention. Do not ride.`;
        else if (answered === total && total) label = `${total} of ${total} answered. All ${total} marked Pass. This checklist is not a safety certification.`;
        if (this.progressLabel) this.progressLabel.textContent = label;
        if (this.progressNext) {
          if (attention) this.progressNext.innerHTML = '<strong>Stop here.</strong> One or more checks need attention. Do not ride.';
          else if (answered === total && total) this.progressNext.innerHTML = '<strong>Checklist complete.</strong> Repeat these checks before every ride.';
          else this.progressNext.innerHTML = `<strong>Next: check ${answered + 1} of ${total}.</strong> Mark every item Pass or Needs attention.`;
        }
        if (this.progressBar) this.progressBar.style.width = total ? `${(answered / total) * 100}%` : '0%';
        if (this.progressTrack) {
          this.progressTrack.setAttribute('aria-valuemax', String(total));
          this.progressTrack.setAttribute('aria-valuenow', String(answered));
          this.progressTrack.setAttribute('aria-valuetext', `${answered} of ${total} answered, ${passed} marked Pass, ${attention} need attention`);
          this.progressTrack.dataset.result = attention ? 'attention' : answered === total && total ? 'pass' : 'in-progress';
        }
        if (this.checkAlert) {
          this.checkAlert.hidden = attention === 0;
          this.checkAlert.textContent = attention
            ? `STOP: ${attention} ${attention === 1 ? 'check needs' : 'checks need'} attention. Do not ride. Keep the bike out of service until the issue is resolved.`
            : '';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ar-user-manuals"] && !Shopify.designMode) return;
  try {
    
(function(){
  var grid = document.querySelector('[data-um-grid]');
  var input = document.querySelector('[data-um-search]');
  if (!grid || !input) return;
  var count = document.querySelector('[data-um-count]');
  var empty = document.querySelector('[data-um-empty]');
  var cards = [].slice.call(grid.querySelectorAll('.ar-manuals__card'));
  function plural(n){ return n + ' ' + (n === 1 ? 'model' : 'models'); }
  function run(){
    var t = input.value.trim().toLowerCase(), n = 0;
    cards.forEach(function(c){
      var hit = !t || c.getAttribute('data-um-name').indexOf(t) > -1;
      c.style.display = hit ? '' : 'none';
      if (hit) n++;
    });
    if (count) count.textContent = plural(n);
    if (empty) empty.hidden = n !== 0;
  }
  input.addEventListener('input', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dealer-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initLocator = (root) => {
      if (!root || root.dataset.dealerReady === '1') return;
      root.dataset.dealerReady = '1';

    const dataEl = root.querySelector('[data-dealer-data]');
    if (!dataEl) return;

    let dealers = [];
    try {
      dealers = JSON.parse(dataEl.textContent || '[]');
    } catch (error) {
      dealers = [];
    }

    const resultsEl = root.querySelector('[data-dealer-results]');
    const summaryEl = root.querySelector('[data-dealer-summary]');
    const metaEl = root.querySelector('[data-dealer-meta]');
    const statEl = root.querySelector('[data-dealer-stat]');
    const serviceFiltersEl = root.querySelector('[data-dealer-service-filters]');
    const emptyEl = root.querySelector('[data-dealer-empty]');
    const idleEl = root.querySelector('[data-dealer-idle]');
    const statusEl = root.querySelector('[data-dealer-status]');
    const form = root.querySelector('[data-dealer-form]');
    const input = root.querySelector('input[name="dealer_zip"]');
    const geoButton = root.querySelector('[data-dealer-geo]');
    const searchButton = form ? form.querySelector('button[type="submit"]') : null;
    const panel = root.querySelector('.dealer-locator__panel');
    const searchButtonLabel = searchButton ? searchButton.textContent : '';
    const geoButtonLabel = geoButton ? geoButton.textContent : '';

    const maxResults = parseInt(root.dataset.maxResults, 10) || 3;
    const radius = parseFloat(root.dataset.radius) || 250;
    const zipCache = new Map();
    let activeResults = [];
    let selectedService = 'all';

    const setStatus = (message, tone = 'neutral') => {
      if (!statusEl) return;
      statusEl.textContent = message || '';
      if (input) input.setAttribute('aria-invalid', tone === 'error' ? 'true' : 'false');
      if (tone === 'error') {
        statusEl.dataset.tone = 'error';
      } else if (tone === 'success') {
        statusEl.dataset.tone = 'success';
      } else {
        statusEl.dataset.tone = 'neutral';
      }
    };

    const setBusy = (busy, source = 'search') => {
      if (searchButton) {
        searchButton.disabled = busy;
        searchButton.textContent = busy && source === 'search' ? 'Searching...' : searchButtonLabel;
      }

      if (geoButton) {
        geoButton.disabled = busy;
        geoButton.textContent = busy && source === 'geo' ? 'Locating...' : geoButtonLabel;
      }

      if (panel) panel.setAttribute('aria-busy', busy ? 'true' : 'false');
    };

    const revealResults = () => {
      if (!panel) return;
      if (window.matchMedia('(max-width: 899px)').matches) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const normalizeZip = (value) => {
      if (!value) return '';
      const match = value.trim().match(/^\d{5}(?:-?\d{4})?$/);
      if (!match) return '';
      return value.trim().substring(0, 5);
    };

    const distanceMiles = (lat1, lon1, lat2, lon2) => {
      const toRad = (deg) => (deg * Math.PI) / 180;
      const R = 3958.8;
      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
      return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
    };

    const getRanked = (lat, lng) =>
      dealers
        .map((dealer) => {
          const dealerLat = parseFloat(dealer.lat);
          const dealerLng = parseFloat(dealer.lng);
          if (!Number.isFinite(dealerLat) || !Number.isFinite(dealerLng)) return null;
          const distance = distanceMiles(lat, lng, dealerLat, dealerLng);
          return { ...dealer, distance };
        })
        .filter(Boolean)
        .sort((a, b) => a.distance - b.distance);

    const formatDistance = (distance) => {
      if (!Number.isFinite(distance) || distance < 0) return '';
      if (distance < 1) return 'Under 1 mi';
      if (distance <= 350) return `${distance.toFixed(1)} mi`;
      if (distance <= 700) return `${Math.round(distance)} mi`;
      return 'Regional partner';
    };

    const formatAddress = (dealer) => {
      const parts = [dealer.address, dealer.city, dealer.state, dealer.zip, dealer.country].filter(Boolean);
      return parts.join(', ');
    };

    const parseServices = (dealer) => {
      const raw = dealer.services;
      const list = Array.isArray(raw) ? raw : String(raw || '').split(',');
      return list.map((item) => String(item).trim()).filter(Boolean);
    };

    const createActionLink = ({ href, label, primary = false, external = false }) => {
      const link = document.createElement('a');
      link.href = href;
      link.textContent = label;
      link.className = primary ? 'dealer-card__action dealer-card__action--primary' : 'dealer-card__action';
      if (external) {
        link.target = '_blank';
        link.rel = 'noopener';
      }
      return link;
    };

    const syncFilterButtonState = () => {
      if (!serviceFiltersEl) return;
      serviceFiltersEl.querySelectorAll('[data-service]').forEach((button) => {
        const isActive = button.dataset.service === selectedService;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    const updateResultStat = (visibleCount, totalCount, closestText) => {
      if (!statEl) return;
      if (!totalCount) {
        statEl.textContent = '';
        return;
      }

      const partnerWord = visibleCount === 1 ? 'partner' : 'partners';
      let text = `Showing ${visibleCount}`;
      if (visibleCount !== totalCount) text += ` of ${totalCount}`;
      text += ` ${partnerWord}`;
      if (closestText) text += ` • Closest ${closestText}`;
      statEl.textContent = text;
    };

    const renderServiceFilters = (items) => {
      if (!serviceFiltersEl) return;
      serviceFiltersEl.innerHTML = '';

      const serviceCounts = new Map();
      items.forEach((dealer) => {
        parseServices(dealer).forEach((service) => {
          serviceCounts.set(service, (serviceCounts.get(service) || 0) + 1);
        });
      });

      const serviceEntries = Array.from(serviceCounts.entries()).sort((a, b) => b[1] - a[1]);
      const allOfferEverything = serviceEntries.every(([, count]) => count === items.length);
      if (serviceEntries.length < 2 || allOfferEverything) {
        serviceFiltersEl.hidden = true;
        return;
      }

      const allButton = document.createElement('button');
      allButton.type = 'button';
      allButton.className = 'dealer-locator__service-filter';
      allButton.dataset.service = 'all';
      allButton.textContent = `All services (${items.length})`;
      serviceFiltersEl.appendChild(allButton);

      serviceEntries.forEach(([service, count]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'dealer-locator__service-filter';
        button.dataset.service = service;
        button.textContent = `${service} (${count})`;
        serviceFiltersEl.appendChild(button);
      });

      serviceFiltersEl.hidden = false;
      syncFilterButtonState();
    };

    const renderCards = (items) => {
      resultsEl.innerHTML = '';

      if (!items.length) {
        const noMatch = document.createElement('div');
        noMatch.className = 'dealer-locator__empty dealer-locator__empty--soft';
        noMatch.textContent = 'No partner in this result set offers that service. Try another filter.';
        resultsEl.appendChild(noMatch);
        return;
      }

      items.forEach((dealer, index) => {
        const card = document.createElement('article');
        card.className = 'dealer-card';
        if (index === 0) card.classList.add('dealer-card--best');

        const top = document.createElement('div');
        top.className = 'dealer-card__top';

        const label = document.createElement('span');
        label.className = 'dealer-card__label';
        if (index === 0) {
          label.classList.add('dealer-card__label--best');
          label.innerHTML = '<svg class="dealer-card__star" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 2 3 6.5 7 .7-5.2 4.7L18 21l-6-3.4L6 21l1.2-7.1L2 9.2l7-.7L12 2Z"></path></svg> Best match';
        } else {
          label.textContent = 'Nearby option';
        }
        top.appendChild(label);

        const distanceText = formatDistance(dealer.distance);
        if (distanceText) {
          const distance = document.createElement('span');
          distance.className = 'dealer-card__distance';
          distance.textContent = distanceText;
          top.appendChild(distance);
        }

        const header = document.createElement('div');
        header.className = 'dealer-card__header';

        const name = document.createElement('h3');
        name.className = 'h5';
        name.textContent = dealer.name || 'Authorized Dealer';
        header.appendChild(name);

        const address = document.createElement('p');
        address.className = 'dealer-card__address';
        address.innerHTML = '<svg class="dealer-card__pin" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>';
        address.appendChild(document.createTextNode(formatAddress(dealer)));
        header.appendChild(address);

        const actions = document.createElement('div');
        actions.className = 'dealer-card__actions';

        const directionsQuery = encodeURIComponent(formatAddress(dealer));
        const actionList = [];

        if (dealer.appointment_url) {
          actionList.push({ key: 'appointment', href: dealer.appointment_url, label: 'Book test ride', external: true });
        }

        if (dealer.website) {
          actionList.push({ key: 'website', href: dealer.website, label: 'Visit website', external: true });
        }

        if (dealer.phone) {
          actionList.push({ key: 'call', href: `tel:${dealer.phone.replace(/[^\d+]/g, '')}`, label: 'Call dealer' });
        }

        if (dealer.email) {
          actionList.push({ key: 'email', href: `mailto:${dealer.email}`, label: 'Email dealer' });
        }

        actionList.push({
          key: 'directions',
          href: `https://www.google.com/maps/search/?api=1&query=${directionsQuery}`,
          label: 'Directions',
          external: true
        });

        let primaryKey = 'directions';
        if (actionList.some((action) => action.key === 'appointment')) primaryKey = 'appointment';
        else if (actionList.some((action) => action.key === 'website')) primaryKey = 'website';

        const visibleActions = [];
        const secondaryActions = [];
        let primaryAssigned = false;

        actionList.forEach((action) => {
          if (!primaryAssigned && action.key === primaryKey) {
            visibleActions.push({ ...action, primary: true });
            primaryAssigned = true;
            return;
          }

          secondaryActions.push(action);
        });

        const quickActionPriority = ['directions', 'call', 'email', 'website'];
        const quickAction = quickActionPriority
          .map((key) => secondaryActions.find((action) => action.key === key))
          .find(Boolean) || secondaryActions[0];

        if (quickAction) {
          visibleActions.push(quickAction);
        }

        visibleActions.forEach((action) => {
          actions.appendChild(
            createActionLink({
              href: action.href,
              label: action.label,
              primary: Boolean(action.primary),
              external: Boolean(action.external)
            })
          );
        });

        const overflowActions = secondaryActions.filter((action) => action !== quickAction);

        let moreOptions;
        if (overflowActions.length) {
          moreOptions = document.createElement('details');
          moreOptions.className = 'dealer-card__more';

          const moreSummary = document.createElement('summary');
          moreSummary.className = 'dealer-card__more-toggle';
          moreSummary.textContent = 'More options';
          moreOptions.appendChild(moreSummary);

          const moreActions = document.createElement('div');
          moreActions.className = 'dealer-card__more-actions';
          overflowActions.forEach((action) => {
            moreActions.appendChild(
              createActionLink({
                href: action.href,
                label: action.label,
                external: Boolean(action.external)
              })
            );
          });
          moreOptions.appendChild(moreActions);
        }

        const tags = document.createElement('div');
        tags.className = 'dealer-card__tags';
        const serviceList = parseServices(dealer);
        serviceList.forEach((service) => {
          const tag = document.createElement('span');
          tag.className = 'dealer-card__tag';
          tag.textContent = service;
          tags.appendChild(tag);
        });

        if (dealer.hours) {
          const hours = document.createElement('p');
          hours.className = 'dealer-card__hours';
          hours.textContent = `Hours: ${dealer.hours}`;
          card.appendChild(top);
          card.appendChild(header);
          if (actions.childNodes.length) card.appendChild(actions);
          if (moreOptions) card.appendChild(moreOptions);
          if (serviceList.length) card.appendChild(tags);
          card.appendChild(hours);
        } else {
          card.appendChild(top);
          card.appendChild(header);
          if (actions.childNodes.length) card.appendChild(actions);
          if (moreOptions) card.appendChild(moreOptions);
          if (serviceList.length) card.appendChild(tags);
        }

        if (dealer.notes) {
          const notes = document.createElement('p');
          notes.className = 'text-subdued';
          notes.textContent = dealer.notes;
          card.appendChild(notes);
        }

        resultsEl.appendChild(card);
      });
    };

    const applyServiceFilter = () => {
      const visibleResults =
        selectedService === 'all'
          ? activeResults
          : activeResults.filter((dealer) => parseServices(dealer).includes(selectedService));

      renderCards(visibleResults);
      const closestText = visibleResults[0] ? formatDistance(visibleResults[0].distance) : '';
      updateResultStat(visibleResults.length, activeResults.length, closestText);
    };

    const render = (items, summaryText, options = {}) => {
      const { showEmpty = false, metaText = 'Distance-ranked options' } = options;
      if (summaryEl) summaryEl.textContent = summaryText;
      if (metaEl) metaEl.textContent = metaText;

      activeResults = Array.isArray(items) ? items : [];
      selectedService = 'all';

      if (!activeResults.length) {
        resultsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = !showEmpty;
        if (idleEl) idleEl.hidden = showEmpty;
        if (serviceFiltersEl) {
          serviceFiltersEl.hidden = true;
          serviceFiltersEl.innerHTML = '';
        }
        updateResultStat(0, 0, '');
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      if (idleEl) idleEl.hidden = true;
      renderServiceFilters(activeResults);
      applyServiceFilter();
      revealResults();
    };

    const lookupZip = async (zip) => {
      if (zipCache.has(zip)) return zipCache.get(zip);
      const response = await fetch(`https://api.zippopotam.us/us/${zip}`);
      if (!response.ok) throw new Error('ZIP not found');
      const data = await response.json();
      zipCache.set(zip, data);
      return data;
    };

    // Dealers without lat/lng are positioned from their own ZIP code, using the
    // same geocoder as the visitor's ZIP. Resolved once per browser (localStorage).
    const coordCacheKey = 'ar-dealer-zip-coords-v1';
    const readCoordCache = () => {
      try {
        return JSON.parse(localStorage.getItem(coordCacheKey) || '{}');
      } catch (error) {
        return {};
      }
    };
    const writeCoordCache = (cache) => {
      try {
        localStorage.setItem(coordCacheKey, JSON.stringify(cache));
      } catch (error) {
        /* storage unavailable: coords stay in-memory for this page view */
      }
    };

    let dealerCoordsPromise = null;
    const ensureDealerCoords = () => {
      if (dealerCoordsPromise) return dealerCoordsPromise;
      dealerCoordsPromise = (async () => {
        const pending = dealers.filter(
          (dealer) =>
            !(Number.isFinite(parseFloat(dealer.lat)) && Number.isFinite(parseFloat(dealer.lng))) &&
            normalizeZip(dealer.zip)
        );
        if (!pending.length) return;

        const cache = readCoordCache();
        let cacheDirty = false;

        await Promise.all(
          pending.map(async (dealer) => {
            const zip = normalizeZip(dealer.zip);
            let coords = cache[zip];
            if (!coords) {
              try {
                const data = await lookupZip(zip);
                const place = data.places && data.places[0];
                const lat = place ? parseFloat(place.latitude) : NaN;
                const lng = place ? parseFloat(place.longitude) : NaN;
                if (Number.isFinite(lat) && Number.isFinite(lng)) {
                  coords = { lat, lng };
                  cache[zip] = coords;
                  cacheDirty = true;
                }
              } catch (error) {
                /* dealer stays unpositioned; excluded from distance ranking */
              }
            }
            if (coords) {
              dealer.lat = coords.lat;
              dealer.lng = coords.lng;
            }
          })
        );

        if (cacheDirty) writeCoordCache(cache);
      })();
      return dealerCoordsPromise;
    };

    const renderNoNearby = (locationLabel) => {
      render([], `No authorized dealer options found within about ${radius} miles of ${locationLabel}.`, {
        showEmpty: true,
        metaText: 'No nearby partners found'
      });
    };

    const renderByCoordinates = (lat, lng, locationLabel) => {
      const ranked = getRanked(lat, lng);
      const matches = ranked.filter((dealer) => dealer.distance <= radius).slice(0, maxResults);

      if (matches.length) {
        render(matches, `Closest Ariel Rider partner options near ${locationLabel}.`, {
          showEmpty: true,
          metaText: `Within about ${radius} miles`
        });
        setStatus(`Showing nearest options for ${locationLabel}.`, 'success');
        return true;
      }

      // Nothing inside the radius: still answer with the single nearest partner
      // instead of a dead end.
      if (ranked.length) {
        render(ranked.slice(0, 1), `No partner within about ${radius} miles of ${locationLabel}. Your nearest option:`, {
          showEmpty: true,
          metaText: 'Nearest partner beyond typical range'
        });
        setStatus(`Nearest partner is outside the ${radius}-mile range. Online orders ship to you directly.`, 'success');
        return true;
      }

      renderNoNearby(locationLabel);
      setStatus(`No nearby dealer options found for ${locationLabel}.`, 'error');
      return false;
    };

    const lookupApproximateLocation = async () => {
      const response = await fetch('https://ipapi.co/json/');
      if (!response.ok) throw new Error('Approximate location unavailable');
      const data = await response.json();
      const lat = parseFloat(data.latitude);
      const lng = parseFloat(data.longitude);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) throw new Error('Approximate location unavailable');
      const city = data.city ? `${data.city}${data.region_code ? `, ${data.region_code}` : ''}` : 'your area';
      return { lat, lng, label: city };
    };

    const handleSearch = async (zip) => {
      if (!dealers.length) {
        render([], 'Dealer information is being updated.', {
          showEmpty: true,
          metaText: 'Dealer feed updating'
        });
        return;
      }

      const normalizedZip = normalizeZip(zip);
      if (!normalizedZip) {
        setStatus('Enter a valid 5-digit ZIP code.', 'error');
        return;
      }

      try {
        setBusy(true, 'search');
        setStatus('Looking up that ZIP code...');
        const [data] = await Promise.all([lookupZip(normalizedZip), ensureDealerCoords()]);
        const place = data.places && data.places[0];
        if (!place) throw new Error('ZIP not found');
        const lat = parseFloat(place.latitude);
        const lng = parseFloat(place.longitude);
        const placeLabel = `${place['place name']}, ${place['state abbreviation']}`;
        renderByCoordinates(lat, lng, placeLabel);
      } catch (error) {
        setStatus('We could not find that ZIP. Try another nearby ZIP code.', 'error');
      } finally {
        setBusy(false);
      }
    };

    const handleGeo = () => {
      if (!navigator.geolocation) {
        setStatus('Location access is not available in this browser.', 'error');
        return;
      }

      setBusy(true, 'geo');
      setStatus('Requesting your location...');
      try {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            ensureDealerCoords().then(() => {
              renderByCoordinates(latitude, longitude, 'your location');
              setBusy(false);
            });
          },
          async (error) => {
            try {
              const approximate = await lookupApproximateLocation();
              await ensureDealerCoords();
              const shown = renderByCoordinates(approximate.lat, approximate.lng, approximate.label);
              if (shown) {
                setStatus('Using approximate location from your network. For best accuracy, enter ZIP.', 'success');
              }
              setBusy(false);
              return;
            } catch (approxError) {
              let message = 'Unable to access your location. Enter a ZIP code instead.';

              if (error && error.code === 1) message = 'Location permission was blocked. Enter a ZIP code instead.';
              if (error && error.code === 2) message = 'Location unavailable right now. Enter a ZIP code instead.';
              if (error && error.code === 3) message = 'Location request timed out. Enter a ZIP code instead.';
              if (window.Shopify && window.Shopify.designMode) {
                message = 'Location is often blocked in Theme Editor preview. Open this page in a normal tab or enter ZIP.';
              }

              setStatus(message, 'error');
              setBusy(false);
            }
          },
          { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 }
        );
      } catch (error) {
        setStatus('Unable to access your location in this view. Enter a ZIP code instead.', 'error');
        setBusy(false);
      }
    };

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        handleSearch(input ? input.value : '');
      });
    }

    if (geoButton) {
      geoButton.addEventListener('click', handleGeo);
    }

    if (input) {
      input.addEventListener('focus', () => ensureDealerCoords(), { once: true });
      input.addEventListener('input', () => {
        if (statusEl && statusEl.dataset.tone === 'error') {
          setStatus('');
        }
      });
    }

    if (serviceFiltersEl) {
      serviceFiltersEl.addEventListener('click', (event) => {
        const button = event.target.closest('[data-service]');
        if (!button) return;

        selectedService = button.dataset.service || 'all';
        syncFilterButtonState();
        applyServiceFilter();
      });
    }

    render([], 'Enter a ZIP code to see the nearest authorized dealers.', {
      showEmpty: false,
      metaText: 'Distance-ranked options'
    });
    };

    const initAll = (scope) => {
      (scope || document).querySelectorAll('[data-dealer-locator]').forEach(initLocator);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebike-laws-state"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.lawReady)return;root.dataset.lawReady='true';
 const select=root.querySelector('[data-state-select]');select?.addEventListener('change',()=>{const url=new URL(select.value,location.origin);if(url.origin===location.origin)location.assign(url.href)});
 const search=root.querySelector('[data-rule-search]'),clear=root.querySelector('[data-clear-search]'),status=root.querySelector('[data-search-status]'),empty=root.querySelector('[data-search-empty]');
 const rows=[...root.querySelectorAll('.ar-state-answer')],groups=[...root.querySelectorAll('[data-rule-group]')];
 const normalize=value=>value.normalize('NFKD').toLocaleLowerCase().replace(/\s+/g,' ').trim();
 const text=new Map(rows.map(row=>[row,normalize([...row.querySelectorAll('summary,.ar-law-answer-card__heading,.ar-law-answer-card__answer,.ar-law-answer-card__notice,.ar-state-answer__copy')].map(part=>part.textContent).join(' '))]));
 const initial=new Map(rows.map(row=>[row,row.open]));
 root.querySelector('[data-law-search]').hidden=false;
 function filter(){const terms=normalize(search.value).split(' ').filter(Boolean);let count=0;rows.forEach(row=>{const match=terms.every(term=>text.get(row).includes(term));row.hidden=!match;if(terms.length)row.open=match;else row.open=initial.get(row);if(match)count++});groups.forEach(group=>group.hidden=![...group.querySelectorAll('.ar-state-answer')].some(row=>!row.hidden));clear.hidden=!terms.length;empty.hidden=count>0;status.textContent=terms.length?`${status.dataset.showing} ${count} ${status.dataset.of} ${rows.length} ${status.dataset.answers}.`:'';}
 search.addEventListener('input',filter);clear.addEventListener('click',()=>{search.value='';filter();search.focus()});
 function openHash(){let id;try{id=decodeURIComponent(location.hash.slice(1))}catch{return}if(!id)return;id=id.replace(/^faq-/,'rule-');const target=document.getElementById(id);if(!target||!root.contains(target))return;if(search.value){search.value='';filter()}const details=target.closest('details');if(details){let parent=details;while(parent){parent.open=true;parent=parent.parentElement?.closest('details')}}requestAnimationFrame(()=>{target.scrollIntoView({block:'start'});const focusTarget=id==='state-switch'?select:target;if(focusTarget){if(!focusTarget.matches('a[href],button,input,select,textarea,summary,[tabindex]'))focusTarget.setAttribute('tabindex','-1');focusTarget.focus({preventScroll:true})}})}
 openHash();window.addEventListener('hashchange',openHash);root.addEventListener('click',e=>{const link=e.target.closest('a[href^="#"]');if(!link||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;let id;try{id=decodeURIComponent(link.hash.slice(1)).replace(/^faq-/,'rule-')}catch{return}const target=document.getElementById(id);if(!target||!root.contains(target))return;e.preventDefault();e.stopPropagation();if(location.hash!==link.hash)history.pushState(null,'',link.hash);openHash()});
 }document.querySelectorAll('[data-state-law-page]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-state-law-page]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kepler-sensor-swap"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.k26 .scba-range').forEach(function (r) {
  var scope = r.closest('.scba');
  if (!scope) return;
  var apply = function () { scope.style.setProperty('--pos', r.value + '%'); };
  r.addEventListener('input', apply);
  apply();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-review-giveaway"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGiveaway = (root) => {
      if (root.dataset.arGiveawayReady === 'true') return;
      root.dataset.arGiveawayReady = 'true';

      const form = root.querySelector('.ar-giveaway__form');
      if (!form) return;

      const entryTypes = Array.from(form.querySelectorAll('[data-entry-type]'));
      const panels = Array.from(form.querySelectorAll('[data-content-panel]'));
      const contentOnly = form.querySelector('[data-content-only]');
      const steps = Array.from(form.querySelectorAll('[data-step]'));
      const progressItems = Array.from(root.querySelectorAll('[data-progress]'));
      const stepBack = form.querySelector('[data-step-back]');
      const stepNext = form.querySelector('[data-step-next]');
      const stepSubmit = form.querySelector('[data-step-submit]');
      const summary = form.querySelector('[data-validation-summary]');
      const youtubeUrl = form.querySelector('[data-youtube-url]');
      const redditUrl = form.querySelector('[data-reddit-url]');
      const duration = form.querySelector('[data-video-duration]');
      const publicGate = form.querySelector('[data-gate="public"]');
      const ageGate = form.querySelector('[data-gate="age"]');
      const stateGate = form.querySelector('[data-eligible-state]');
      const routingBody = form.querySelector('[data-routing-body]');
      const submittedAt = form.querySelector('[data-submitted-at]');
      const entryId = form.querySelector('[data-entry-id]');
      const followupTags = root.querySelector('[data-followup-tags]');
      const featureContact = root.querySelector('[data-feature-contact]');
      const excludedStates = new Set(
        (root.dataset.excludedStates || '')
          .split(',')
          .map((stateName) => stateName.trim())
          .filter(Boolean)
      );
      const eligibleGeography = root.dataset.eligibleGeography || '';
      let currentStep = 1;

      const track = (eventName, details = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          giveaway_campaign_id: root.dataset.campaignId || '',
          giveaway_status: root.dataset.campaignStatus || '',
          ...details
        });
      };

      const setAttribution = (key, value) => {
        const field = form.querySelector(`[data-attribution="${key}"]`);
        if (field) field.value = value || '';
      };

      const query = new URLSearchParams(window.location.search);
      const entryStart = Date.parse(root.dataset.entryStart || '');
      const campaignDay = Number.isFinite(entryStart) && Date.now() >= entryStart
        ? Math.max(1, Math.floor((Date.now() - entryStart) / 86400000) + 1)
        : '';
      setAttribution('landing-url', window.location.href.split('#')[0]);
      setAttribution('referrer', document.referrer);
      setAttribution('utm-source', query.get('utm_source'));
      setAttribution('utm-medium', query.get('utm_medium'));
      setAttribution('utm-campaign', query.get('utm_campaign'));
      setAttribution('utm-content', query.get('utm_content'));
      setAttribution('device', window.matchMedia('(max-width: 760px)').matches ? 'mobile' : 'desktop');
      setAttribution('campaign-day', String(campaignDay));

      const fixedHeaderOffset = () => {
        const candidates = Array.from(document.querySelectorAll(
          '.shopify-section-group-header-group, .shopify-section--announcement-bar, sticky-header, header[role="banner"]'
        ));
        return candidates.reduce((largestBottom, element) => {
          const style = window.getComputedStyle(element);
          const rect = element.getBoundingClientRect();
          const overlaysContent = (style.position === 'fixed' || style.position === 'sticky')
            && rect.height > 0
            && rect.top <= 20
            && rect.bottom < window.innerHeight * 0.6;
          return overlaysContent ? Math.max(largestBottom, rect.bottom) : largestBottom;
        }, 0);
      };

      const scrollTargetIntoView = (target) => {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const top = window.scrollY + target.getBoundingClientRect().top - fixedHeaderOffset() - 16;
        window.scrollTo({ top: Math.max(0, top), behavior });
      };

      const syncGorgiasVisibility = () => {
        const applyVisibility = () => {
          if (!window.GorgiasChat || typeof window.GorgiasChat.hideChat !== 'function') return;
          const initialization = typeof window.GorgiasChat.init === 'function'
            ? window.GorgiasChat.init()
            : Promise.resolve();
          Promise.resolve(initialization)
            .then(() => window.GorgiasChat.hideChat(window.location.hash === '#entry-form'))
            .catch(() => {});
        };

        if (window.GorgiasChat) {
          applyVisibility();
        } else if (root.dataset.gorgiasVisibilityBound !== 'true') {
          root.dataset.gorgiasVisibilityBound = 'true';
          window.addEventListener('gorgias-widget-loaded', applyVisibility);
        }
      };

      const syncPageMode = () => {
        const entryIsActive = window.location.hash === '#entry-form';
        document.documentElement.classList.toggle('ar-giveaway-entry-active', entryIsActive);
        root.dataset.activeView = entryIsActive ? 'entry' : 'details';
        syncGorgiasVisibility();
      };

      syncPageMode();
      window.addEventListener('hashchange', syncPageMode);

      root.querySelectorAll('[data-section-link]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const selector = link.getAttribute('href');
          const target = selector ? root.querySelector(selector) : null;
          if (!target) return;
          event.preventDefault();
          window.history.pushState(null, '', selector);
          scrollTargetIntoView(target);
          track('giveaway_section_navigation', { giveaway_destination: selector });
        });
      });

      const createEntryId = () => {
        const campaign = valueOf('[name="contact[Campaign ID]"]') || 'grizzly-72v';
        const randomPart = window.crypto?.randomUUID
          ? window.crypto.randomUUID().split('-')[0]
          : Math.random().toString(36).slice(2, 10);
        return `${campaign}-${Date.now().toString(36)}-${randomPart}`.toUpperCase();
      };

      const selectedEntryType = () => form.querySelector('[data-entry-type]:checked')?.value || '';

      const showError = (message, field) => {
        summary.textContent = message;
        summary.hidden = false;
        summary.focus();
        if (field) field.focus();
      };

      const clearError = () => {
        summary.textContent = '';
        summary.hidden = true;
      };

      const isYouTubeVideo = (value) => {
        try {
          const url = new URL(value);
          const host = url.hostname.replace(/^www\./, '');
          if (host === 'youtu.be') return url.pathname.split('/').filter(Boolean).length === 1;
          if (host === 'youtube.com' || host.endsWith('.youtube.com')) {
            return (url.pathname === '/watch' && Boolean(url.searchParams.get('v'))) || url.pathname.startsWith('/shorts/') || url.pathname.startsWith('/live/');
          }
        } catch (error) {
          return false;
        }
        return false;
      };

      const isRedditPost = (value) => {
        try {
          const url = new URL(value);
          const host = url.hostname.replace(/^www\./, '');
          if (host === 'redd.it') return url.pathname.split('/').filter(Boolean).length === 1;
          return (host === 'reddit.com' || host.endsWith('.reddit.com')) && /\/comments\/[^/]+/i.test(url.pathname);
        } catch (error) {
          return false;
        }
      };

      const updatePanels = () => {
        const selected = selectedEntryType();
        panels.forEach((panel) => {
          const active = panel.dataset.contentPanel === selected;
          panel.hidden = !active;
          panel.querySelectorAll('input, select, textarea').forEach((field) => {
            field.disabled = !active;
          });
          panel.querySelectorAll('[data-content-required]').forEach((field) => {
            field.required = active;
          });
        });
        const hasContent = selected === 'YouTube video' || selected === 'Reddit post';
        contentOnly.hidden = !hasContent;
        contentOnly.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !hasContent;
        });
        contentOnly.querySelectorAll('[data-content-required]').forEach((field) => {
          field.required = hasContent;
        });
        clearError();
      };

      root.querySelectorAll('[data-entry-link]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const method = link.dataset.methodChoice;
          if (method) {
            const matchingInput = entryTypes.find((input) => input.value === method);
            if (matchingInput) matchingInput.checked = true;
          }
          track('giveaway_method_selected', { giveaway_entry_method: method || 'not selected' });
          updatePanels();
          currentStep = 1;
          updateStep(false);
          window.location.hash = 'entry-form';
          window.requestAnimationFrame(() => root.querySelector('.ar-giveaway__back')?.focus());
        });
      });

      root.querySelectorAll('[data-entry-back]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          window.location.hash = 'giveaway-details';
          window.requestAnimationFrame(() => root.querySelector('.ar-giveaway__hero .button')?.focus());
        });
      });

      const queryMethod = new URLSearchParams(window.location.search).get('method');
      const methodMap = { youtube: 'YouTube video', reddit: 'Reddit post' };
      if (queryMethod && methodMap[queryMethod]) {
        const matchingInput = entryTypes.find((input) => input.value === methodMap[queryMethod]);
        if (matchingInput) matchingInput.checked = true;
        updatePanels();
      }

      const valueOf = (selector) => {
        const field = form.querySelector(selector);
        return field && field.value ? field.value.trim() : '';
      };

      const buildRoutingBody = () => {
        const selected = selectedEntryType();
        const isYouTubeEntry = selected === 'YouTube video';
        const isRedditEntry = selected === 'Reddit post';
        const isContentEntry = isYouTubeEntry || isRedditEntry;
        const lines = [
          'AR-GRIZZLY-DRAWING-ENTRY',
          `Campaign ID: ${valueOf('[name="contact[Campaign ID]"]')}`,
          `Entry method: ${selected}`,
          `Entrant name: ${valueOf('[name="contact[name]"]')}`,
          `Entrant email: ${valueOf('[name="contact[email]"]')}`,
          `State: ${valueOf('[name="contact[State of residence]"]')}`,
          `Age eligibility confirmed: ${ageGate.value}`,
          `YouTube URL: ${isYouTubeEntry ? youtubeUrl.value.trim() : ''}`,
          `Video duration in minutes: ${isYouTubeEntry ? duration.value.trim() : ''}`,
          `Reddit URL: ${isRedditEntry ? redditUrl.value.trim() : ''}`,
          `Ariel Rider model: ${valueOf('[name="contact[Ariel Rider model]"]')}`,
          `Content public: ${isContentEntry ? publicGate.value : ''}`,
          `Notes: ${valueOf('[data-entry-notes]')}`,
          'Selection method: Random drawing from all eligible entries',
          'Purchase required: No',
          `Eligible geography: ${eligibleGeography}`,
          `Landing URL: ${valueOf('[data-attribution="landing-url"]')}`,
          `Referrer: ${valueOf('[data-attribution="referrer"]')}`,
          `UTM source: ${valueOf('[data-attribution="utm-source"]')}`,
          `UTM medium: ${valueOf('[data-attribution="utm-medium"]')}`,
          `UTM campaign: ${valueOf('[data-attribution="utm-campaign"]')}`,
          `UTM content: ${valueOf('[data-attribution="utm-content"]')}`,
          `Visitor device: ${valueOf('[data-attribution="device"]')}`,
          `Campaign day: ${valueOf('[data-attribution="campaign-day"]')}`,
          `Entry ID: ${entryId.value}`,
          'Eligibility decision: Pending human review'
        ];
        routingBody.value = lines.join('\n');
        submittedAt.value = new Date().toISOString();
      };

      const fillReview = () => {
        const selected = selectedEntryType();
        let submittedLink = root.dataset.reviewNotRequired;
        if (selected === 'YouTube video') submittedLink = youtubeUrl.value.trim() || root.dataset.reviewNotProvided;
        if (selected === 'Reddit post') submittedLink = redditUrl.value.trim() || root.dataset.reviewNotProvided;
        const values = {
          name: valueOf('[name="contact[name]"]') || root.dataset.reviewNotProvided,
          email: valueOf('[name="contact[email]"]') || root.dataset.reviewNotProvided,
          state: stateGate.value || root.dataset.reviewNotProvided,
          model: valueOf('[name="contact[Ariel Rider model]"]') || root.dataset.reviewNotProvided,
          method: selected || root.dataset.reviewNotProvided,
          link: submittedLink
        };
        Object.entries(values).forEach(([key, value]) => {
          const target = form.querySelector(`[data-review="${key}"]`);
          if (target) target.textContent = value;
        });
      };

      const updateStep = (moveFocus = true) => {
        steps.forEach((step) => {
          const active = Number(step.dataset.step) === currentStep;
          step.hidden = !active;
          step.classList.toggle('is-entering', active);
        });
        progressItems.forEach((item) => {
          const stepNumber = Number(item.dataset.progress);
          const active = stepNumber === currentStep;
          item.classList.toggle('is-active', active);
          item.classList.toggle('is-done', stepNumber < currentStep);
          if (active) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
        });
        stepBack.hidden = currentStep === 1;
        stepNext.hidden = currentStep === 3;
        stepSubmit.hidden = currentStep !== 3;
        if (currentStep === 3) fillReview();
        if (moveFocus) {
          const legend = steps.find((step) => Number(step.dataset.step) === currentStep)?.querySelector('legend');
          if (legend) {
            legend.tabIndex = -1;
            legend.focus({ preventScroll: true });
          }
        }
      };

      const activeStepIsValid = () => {
        clearError();
        const activeStep = steps.find((step) => Number(step.dataset.step) === currentStep);
        if (!activeStep) return false;
        const checkedGroups = new Set();
        const requiredFields = Array.from(activeStep.querySelectorAll('[required]')).filter((field) => !field.disabled);
        for (const field of requiredFields) {
          if (field.type === 'radio') {
            if (checkedGroups.has(field.name)) continue;
            checkedGroups.add(field.name);
            if (!form.querySelector(`[name="${field.name}"]:checked`)) {
              field.reportValidity();
              return false;
            }
            continue;
          }
          if (!field.checkValidity()) {
            field.reportValidity();
            return false;
          }
        }

        if (currentStep === 1) {
          if (excludedStates.has(stateGate.value)) {
            showError(root.dataset.errorState, stateGate);
            return false;
          }
          if (ageGate.value !== 'Yes') {
            showError(root.dataset.errorAge, ageGate);
            return false;
          }
        }

        if (currentStep === 2) {
          const selected = selectedEntryType();
          if (selected === 'YouTube video' && !isYouTubeVideo(youtubeUrl.value)) {
            showError(root.dataset.errorYoutube, youtubeUrl);
            return false;
          }
          if (selected === 'YouTube video' && Number(duration.value) < 2) {
            showError(root.dataset.errorDuration, duration);
            return false;
          }
          if (selected === 'Reddit post' && !isRedditPost(redditUrl.value)) {
            showError(root.dataset.errorReddit, redditUrl);
            return false;
          }
          if ((selected === 'YouTube video' || selected === 'Reddit post') && publicGate.value !== 'Yes') {
            showError(root.dataset.errorPublic, publicGate);
            return false;
          }
        }
        return true;
      };

      const moveToEntryTop = () => {
        const top = root.querySelector('.ar-giveaway__entry-top');
        if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      entryTypes.forEach((input) => input.addEventListener('change', updatePanels));
      stepNext.addEventListener('click', () => {
        if (!activeStepIsValid()) return;
        track('giveaway_form_step_completed', { giveaway_step: currentStep });
        currentStep = Math.min(3, currentStep + 1);
        updateStep();
        moveToEntryTop();
      });
      stepBack.addEventListener('click', () => {
        currentStep = Math.max(1, currentStep - 1);
        updateStep();
        moveToEntryTop();
      });
      if (followupTags && featureContact) {
        featureContact.addEventListener('change', () => {
          followupTags.value = featureContact.checked
            ? 'newsletter,giveaway-owner-updates,giveaway-feature-contact'
            : 'newsletter,giveaway-owner-updates';
        });
      }

      form.addEventListener('submit', (event) => {
        clearError();
        const selected = selectedEntryType();

        if (excludedStates.has(stateGate.value)) {
          event.preventDefault();
          currentStep = 1;
          updateStep(false);
          showError(root.dataset.errorState, stateGate);
          return;
        }

        if (selected === 'YouTube video' && !isYouTubeVideo(youtubeUrl.value)) {
          event.preventDefault();
          showError(root.dataset.errorYoutube, youtubeUrl);
          return;
        }
        if (selected === 'YouTube video' && Number(duration.value) < 2) {
          event.preventDefault();
          showError(root.dataset.errorDuration, duration);
          return;
        }
        if (selected === 'Reddit post' && !isRedditPost(redditUrl.value)) {
          event.preventDefault();
          showError(root.dataset.errorReddit, redditUrl);
          return;
        }
        if ((selected === 'YouTube video' || selected === 'Reddit post') && publicGate.value !== 'Yes') {
          event.preventDefault();
          showError(root.dataset.errorPublic, publicGate);
          return;
        }
        if (ageGate.value !== 'Yes') {
          event.preventDefault();
          showError(root.dataset.errorAge, ageGate);
          return;
        }
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }
        buildRoutingBody();
        track('giveaway_submission_attempted', { giveaway_entry_method: selected });
      });

      entryId.value = entryId.value || createEntryId();
      updatePanels();
      updateStep(false);
      track('giveaway_page_viewed');
      root.querySelector('[data-klaviyo-reminder-form]')?.closest('.ar-giveaway__reminder')?.addEventListener('click', () => {
        track('giveaway_reminder_engaged');
      }, { once: true });
      const success = form.querySelector('[data-form-success]');
      if (success) {
        window.location.hash = 'entry-form';
        success.focus();
      }
      const newsletterSuccess = root.querySelector('[data-newsletter-success]');
      const postEntryOptin = root.querySelector('[data-post-entry-optin]');
      if (newsletterSuccess && postEntryOptin instanceof HTMLDetailsElement) {
        postEntryOptin.open = true;
        newsletterSuccess.focus();
      }
    };

    const boot = () => document.querySelectorAll('[data-ar-giveaway]').forEach(initGiveaway);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', (event) => {
      const selectedBlock = event.target;
      if (!(selectedBlock instanceof HTMLElement)) return;
      const parentDetails = selectedBlock.closest('details');
      if (parentDetails) parentDetails.open = true;
      selectedBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
